import Axios from 'axios';
import { getItem, removeItem } from './utils/localStorage';

// Store a callback for showing the forbidden dialog
let showForbiddenDialogCallback = null;

// Explicitly export the function
export function setForbiddenDialogCallback(callback) {
  showForbiddenDialogCallback = callback;
}

const axiosInstance = Axios.create({
  baseURL: 'https://www.vassbot.com/apis',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json, text/plain, */*',
  },
  timeout: 20000,
});

// Request interceptor to add Authorization header
axiosInstance.interceptors.request.use(
  config => {
    const token = getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Response interceptor to handle 401, 422, and 403
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      const { status } = error.response;
      if ([401, 422].includes(status)) {
        removeItem('access_token');
        removeItem('refreshed_at');
        
      }
      if (status === 403) {
        const dialogData = {
          title: 'Forbidden!',
          message: 'You have insufficient rights to perform this action. Please contact admin!',
        };
        // Trigger the dialog if a callback is registered
        if (showForbiddenDialogCallback) {
          showForbiddenDialogCallback(dialogData);
        }
        return Promise.reject({
          ...error,
          response: {
            ...error.response,
            data: {
              status: 'error',
              dialog: {
                type: 'forbidden',
                ...dialogData,
              },
            },
          },
        });
      }
    }
    return Promise.reject(error);
  }
);

// Export axiosInstance as default
export default axiosInstance;